import urlJoin from "url-join";
import { Settings } from "../Settings";
import { EnumFormFeedBackType } from "./enums/EnumFormFeedbackType";
import { EnumProductSort } from "./enums/EnumProductSort";
import { EnumSortDirection } from "./enums/EnumSortDirection";
import { JsonProductCategory } from "./json-data-types/JsonProductCategory";
import { JsonProductList } from "./json-data-types/JsonProductList";

export module UrlGenerator{

    export function productSearch(
        { query, productType = Settings.productTypeAll, pageNumber = 1, productsPerPage = Settings.countOfProductsPerPage, productColor = Settings.productColorAll }: { query: string; productType?: string; pageNumber?: number; productsPerPage?: number; productColor?:string }    ):string{
        if(pageNumber<1) pageNumber = 1
        return Settings.addPrefixForUrl(`/product-search/${query.trim()}/${productType}/${productColor}/${pageNumber}/${productsPerPage}`)
    }

    export function productsByCategoryParameters(p:{
        categoryId:number, 
        productType:string,
        sortBy:EnumProductSort,
        sortDirection:EnumSortDirection,
        pageNumber?:number,
        productsPerPage?:number,
        productColor?:string
    }):string{
        if(!p.pageNumber || p.pageNumber <1) {
            p.pageNumber = 1
        }
        if(!p.productsPerPage){
            p.productsPerPage = Settings.countOfProductsPerPage
        }
        if(!p.productColor){
            p.productColor = Settings.productColorAll
        }
        return Settings.addPrefixForUrl( `/shop/${p.categoryId}/${p.productType}/${p.productColor}/${p.sortBy}/${p.sortDirection}/${p.pageNumber}/${p.productsPerPage}`)
    }

    export function productsByCategoryWithDefaultParameters(p:{
        category:JsonProductCategory,
        productType?:string, 
        pageNumber?:number,
        productsPerPage?:number,
        productColor?:string
    }){
        if(!p.category) throw new Error('no p.category')
        if(!p.pageNumber || p.pageNumber<1){
            p.pageNumber = 1
        }
        if(!p.productType){
            p.productType = Settings.productTypeAll
        }
        if(!p.productsPerPage){
            p.productsPerPage = Settings.countOfProductsPerPage
        }
        if(!p.productColor){
            p.productColor = Settings.productColorAll
        }

        return Settings.addPrefixForUrl( `/shop/${p.category.id}/${p.productType}/${p.productColor}/${p.category.defaultSort || EnumProductSort.Name}/${p.category.defaultSortDirection || EnumSortDirection.Asc}/${p.pageNumber}/${p.productsPerPage}`)
    }

    export function productsByListParameters({ 
        listId, productType, sortBy, sortDirection, pageNumber = 1, productsPerPage = Settings.countOfProductsPerPage }: { 
            listId: string; 
            productType: string; 
            sortBy: EnumProductSort; 
            sortDirection: EnumSortDirection; 
            pageNumber?: number; 
            productsPerPage?: number; 
        }):string{
        if(pageNumber<1) pageNumber = 1
        return Settings.addPrefixForUrl(`/list/${listId}/${productType}/${sortBy}/${sortDirection}/${pageNumber}/${productsPerPage}`)
    }

    export function productsByListWithDefaultParameters(p:{
        listId?:string,
        slug?:string,
        list?:JsonProductList,
    }){
        const listIdOrSlug = p.slug || p.list?.slug || p.listId
        return Settings.addPrefixForUrl(`/list/${listIdOrSlug}`)
    }




    export const product = (productUrl:string, productId:number) => Settings.addPrefixForUrl(`/product/${productUrl || productId}`)

    export const home = Settings.addPrefixForUrl('/')
    export const register = Settings.addPrefixForUrl('/register')
    export const registerWholeSale = Settings.addPrefixForUrl('/register/wholesale')
    export const registerRetail = Settings.addPrefixForUrl('/register/retail')
    export const login = Settings.addPrefixForUrl('/login')
    
    export const profile = Settings.addPrefixForUrl('/profile')
    export const editUser = Settings.addPrefixForUrl('/edit')
    export const logout = Settings.addPrefixForUrl('/logout')
    export const relogin = Settings.addPrefixForUrl('/relogin')
    export const changePassword = Settings.addPrefixForUrl('/change-password')
    export const resetPassword = Settings.addPrefixForUrl('/reset-password')

    export const confirmResetPassword = Settings.addPrefixForUrl('')
    export const basket = (scrollToProductId:number=0) => Settings.addPrefixForUrl(`/basket/${scrollToProductId}`)

    export const favorites = Settings.addPrefixForUrl('/favorites')
    export const makeOrder = (scrollToProductId:number=0) => Settings.addPrefixForUrl(`/order/${scrollToProductId}`)

    export const pageNewOrderSuccessful = Settings.addPrefixForUrl('/new-order-successful')

    export const orderItems = (orderId:number) => Settings.addPrefixForUrl(`/order-items/${orderId}`)

    export const galleryAlbums = Settings.addPrefixForUrl('/gallery')
    export function galleryPhotos(albumId:number){
        return Settings.addPrefixForUrl(`/gallery/${albumId}`)
    }

    export const payForOrder = (orderId:number) => Settings.addPrefixForUrl(`/pay/${orderId}`)

    export const afterPayment = (orderId:number) => Settings.addPrefixForUrl(`/after-payment/${orderId}`)

    export function feedback(type:EnumFormFeedBackType){
        return Settings.addPrefixForUrl(`/feedback/${type}`)
    }

    export const buyCoupons = '/podarochniy-sertifikat'
    export const buyCouponsInfo = '/podarochniy-sertifikat-info'
    export const club = Settings.addPrefixForUrl('/club')

    export const adminProductLists = '/admin/productlists'

    export function blogPost(url:string){
        return Settings.addPrefixForUrl(urlJoin('/blog', url))
    }

    export const blog = `/blog`
}